import { AWS_IMAGES_BUCKET } from 'constants/api';
import ERROR_MESSAGE from 'constants/errorMessage';
import handleErrorMessageAPI from 'global/AlertErrorMessage';

import streamApi from 'lib/api/stream';
import { generateId } from './uploadFile';

const domToImage = require('dom-to-image');

function formatUploadImageName(formattype, prefix = 'stockbit') {
  const randomId = generateId();
  // old code: moment().format()
  const tzOffset = new Date().getTimezoneOffset() * 60000;
  const localISOTime = new Date(Date.now() - tzOffset)
    .toISOString()
    .slice(0, -1);

  let now = localISOTime;
  now = now.replace(/-/g, '');
  now = now.replace(/:/g, '');
  now = now.substr(0, 15);

  return `${prefix + randomId + now}web.${formattype}`;
}

function dataURItoBlob(dataURI) {
  const binary = atob(dataURI.split(',')[1]);
  const array = [];
  for (let i = 0; i < binary.length; i += 1) {
    array.push(binary.charCodeAt(i));
  }
  return new Blob([new Uint8Array(array)], { type: 'image/jpeg' });
}

function base64ToImage(base64) {
  let rawBase64 = base64.split(',');
  //   original code: rawBase64 = rawBase64[1];
  const [, base64ORawData] = rawBase64;
  rawBase64 = base64ORawData;

  const fileName = `${Date.now()}.jpeg`;
  const blob = dataURItoBlob(base64);
  const file = new File([blob], fileName);

  return file;
}

function capitalizeFirstLetter(string) {
  if (!string) return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
}

// originally from web legacy, there's params quality
// but never in used
function imageCompressor(sourceImage, outputFormat) {
  let methodName = `to${capitalizeFirstLetter(outputFormat)}`;
  if (typeof domToImage[methodName] !== 'function') {
    methodName = 'toJpeg';
  }
  return domToImage[methodName](sourceImage, { quality: 0.6 }).catch(() => {
    /** TODO: Handle error correctly */
  });
}

function lastSlashURL(url) {
  return url.substr(url.lastIndexOf('/') + 1);
}

function uploadPromise(file, token) {
  let newfilename;
  // If attachment is url return the url immediately
  if (typeof file === 'string' && file.indexOf('http') !== -1) {
    return Promise.resolve({ data: { url: file } });
  }

  if (file) {
    const filetype = file.type.split('/')[1];
    newfilename = formatUploadImageName(filetype, 'stream');
  }

  const fd = new FormData();
  let formerFile = null;
  // eslint-disable-next-line no-underscore-dangle
  if (file._file) formerFile = file._file;

  // fd.append('key', file['name'])
  fd.append('key', newfilename);
  fd.append('AWSAccessKeyId', token.AWSAccessKeyId);
  fd.append('acl', 'public-read');
  fd.append('success_action_redirect', token.success_action_redirect);
  fd.append('policy', token.policy);
  fd.append('signature', token.signature);
  fd.append('Content-Type', '');

  if (!formerFile) {
    fd.append('file', file);
  } else {
    fd.append('file', formerFile);
  }

  return fetch(AWS_IMAGES_BUCKET, {
    method: 'POST',
    cache: 'default',
    body: fd,
    mode: 'cors',
  })
    .then((response) => response.json())
    .catch((error) => {
      handleErrorMessageAPI(
        ERROR_MESSAGE.STREAM_ERROR_UPLOAD_FILE,
        ERROR_MESSAGE.ALERT_RED,
      );
      return error;
    });
}

/**
 * Upload files stacked into Amazon S3
 * @param {any} file
 * @returns {Object}
 */
function uploadImage(file) {
  const bucket = 'stockbit';
  return streamApi.getUploadToken(bucket).then((res) => {
    const {
      data: { data: token },
    } = res;

    return uploadPromise(file, token);
  });
}

export default {
  formatUploadImageName,
  imageCompressor,
  base64ToImage,
  lastSlashURL,
  uploadImage,
};
